import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=5eab8322&"
import script from "./Callback.vue?vue&type=script&lang=js&"
export * from "./Callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eab8322')) {
      api.createRecord('5eab8322', component.options)
    } else {
      api.reload('5eab8322', component.options)
    }
    module.hot.accept("./Callback.vue?vue&type=template&id=5eab8322&", function () {
      api.rerender('5eab8322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Pages/Callback.vue"
export default component.exports